export default {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  'USER-ACTION-LOG': {
    TITLE: 'Action history',
    TABS: {
      CANDIDATES: 'Candidates',
      OFFERS_BRANCHES: 'Offers & branches',
      SAAS_USERS: 'User management',
    },
    TABLE: {
      TITLE: 'Action history',
      TOTAL: '{{total}} records found',
      CANDIDATES: 'Candidates',
      NO_DATA: 'No activity records match the applied filters.',
      DELETED_USER: 'Deleted user',
      DELETED_OFFER: 'Deleted job',
      VIEW_DETAIL: 'View detail',
      VIEW_OFFER: 'View job offer',
      VIEW_CANDIDATE: 'View candidate',
      TYPE_BULK: 'Bulk',
      TYPE_INDIVIDUAL: 'Individual',
      HEADER: {
        ACTOR: 'Company user',
        TARGET: 'Candidate',
        ACTION: 'Action',
        CONTEXT: 'Type',
        OFFER: 'Job',
        OFFER_PUBLISHED: 'Published',
        DATE: 'Date & Time',
        ACTIONS: 'Actions',
        CANDIDATES: 'Candidates',
      },
    },
    FILTERS: {
      ACTION: 'Filter by action',
      DATE_FROM: 'Start date',
      DATE_TO: 'End date',
      CLEAR: 'Clear filters',
      SEARCH: 'Search by email, job...',
    },
    ACTIONS: {
      CHAT: 'Message sent',
      CANCELLATION: 'Candidate moved to Rejected',
      SELECT: 'Candidate moved to Finalists',
      INTERESTING: 'Candidate moved to Shortlisted',
      RE_SEND_INTERVIEW: 'Interview resent',
      SEND_INTERVIEW: 'Interview sent',
      ROLLBACK_DISCARD: 'Candidate restored',
      BACK_TO_REVIEW: 'Candidate moved to Under Review',
      SEND_SPECIFIC_QUESTIONS: 'Direct questions sent',
      SEND_OFFER_TO_SUGGESTED: 'Offer sent to suggested candidate',
      MESSAGE_DELETE: 'Message deleted',
      MESSAGE_EDIT: 'Message edited',
      MESSAGE_SEND: 'Chat message sent',
      ADD_NOTE: 'Note added',
      NOTE_EDIT: 'Note edited',
      NOTE_DELETE: 'Note deleted',
    },
    CONTEXTS: {
      APPLY_OFFER_ACTION_MULTIPLE: 'Bulk action on candidates',
      APPLY_OFFER_ACTION_INDIVIDUAL: 'Individual action',
      CHAT_MESSAGE_DELETE: 'Message deleted',
      CHAT_MESSAGE_EDIT: 'Message edited',
      CHAT_MESSAGE_SEND: 'Message sent',
      APPLY_OFFER_NOTE_ADD: 'Note added',
      APPLY_OFFER_NOTE_EDIT: 'Note edited',
      APPLY_OFFER_NOTE_DELETE: 'Note deleted',
    },
    DETAIL: {
      TITLE: 'Action history',
      NOT_FOUND: 'This audit record was not found, or you do not have access to it.',
      BACK_TO_LIST: 'Back to list',
      SECTION_TITLE: 'Log detail',
      ACTOR: 'Company user',
      TARGET: 'Candidate',
      ACTION_DETAILS: 'Action details',
      METADATA: 'Additional data',
      MESSAGE: 'Message sent',
      REASON: 'Rejection reason',
      NO_REASON: 'No reason provided',
      QUESTIONS: 'Questions sent',
      NOTE: 'Note',
      PREVIOUS_CONTENT: 'Previous content',
      NEW_CONTENT: 'New content',
      GO_TO_OFFER: 'View job offer',
      GO_TO_CANDIDATE: 'View candidate',
      TYPE: 'Type',
    },
    OFFER_BRANCH: {
      TABLE: {
        HEADER: {
          ACTOR: 'User',
          ACTION: 'Action',
          ENTITY_LOCATION: 'Branch',
          AFFECTED_OFFERS: 'Job',
        },
        OFFERS: 'Offers',
      },
      ACTIONS: {
        OFFER_CREATE: 'Offer created',
        OFFER_UPDATE: 'Offer edited',
        OFFER_DELETE: 'Offer deleted',
        OFFER_PUBLISH: 'Offer published',
        OFFER_CHANGE_STATUS: 'Offer status changed',
        OFFER_PAUSE: 'Offer paused',
        OFFER_FINISH: 'Offer finished',
        OFFER_REOPEN: 'Offer reopened',
        OFFER_DUPLICATE: 'Offer duplicated',
        ENTITY_LOCATION_CREATE: 'Branch created',
        ENTITY_LOCATION_UPDATE: 'Branch edited',
        ENTITY_LOCATION_DELETE: 'Branch deleted',
      },
      CONTEXTS: {
        OFFER_ACTION: 'Offer action',
        ENTITY_LOCATION_ACTION: 'Branch action',
      },
      DETAIL: {
        ENTITY_LOCATION: 'Branch',
        STATUS_CHANGE: 'Status change',
        REASON: 'Reason',
        SOURCE_OFFER: 'Source offer',
      },
    },
    SAAS_USER: {
      TABLE: {
        HEADER: {
          ACTOR: 'Sender user',
          ACTOR_TOOLTIP: 'User who performs the action',
          ACTION: 'Action',
          TARGET: 'Recipient user',
          TARGET_TOOLTIP: 'Recipient of the action',
          DATE: 'Date and time',
        },
      },
      ACTIONS: {
        SAAS_USER_CREATE: 'User created',
        SAAS_USER_DELETE: 'User deleted',
        SAAS_USER_PERMISSIONS_UPDATE: 'Permissions changed',
      },
      CONTEXTS: {
        SAAS_USER_ACTION: 'User management',
      },
      // Full sentences with parameters: word order differs between languages.
      SUMMARY: {
        SAAS_USER_CREATE: '{{actor}} created {{target}}',
        SAAS_USER_DELETE: '{{actor}} deleted {{target}}',
        SAAS_USER_PERMISSIONS_UPDATE: '{{actor}} changed the permissions of {{target}}',
      },
      DETAIL: {
        ACTOR: 'Sender user',
        TARGET: 'Recipient user',
        ROLE: 'Role',
        NO_ROLE: 'No role',
        INITIAL_PERMISSIONS: 'Initial permissions',
        BEFORE: 'Before',
        AFTER: 'After',
        SCOPED_ROLES: 'Scoped roles',
        NO_SCOPED_ROLES: 'No scoped roles',
        ADDED: 'Added',
        REMOVED: 'Removed',
        NO_CHANGES: 'No changes in scoped roles',
        // Shown when the scope name cannot be resolved: "Branch #10"
        SCOPE_WITH_ID: '{{type}} #{{id}}',
      },
      SCOPE_TYPES: {
        entity: 'Company',
        entity_location: 'Branch',
        offer: 'Offer',
      },
      FILTERS: {
        SEARCH: 'Search by email...',
      },
    },
  },
} as const;
